import { HoverableLink } from '@paywithextend/components'
import React from 'react'
import { useDispatch } from 'react-redux'
import Button, {
  ButtonDesigns,
  ButtonTypes,
} from 'src/components/Button/Button'
import ErrorList from 'src/components/ErrorList/ErrorList'
import TestId from 'src/components/TestId/TestId'
import { useTranslate } from 'src/localization/Trns'
import { closeModal } from 'src/navigation/Lnk'
import { css } from 'styled-components'

interface ModalDialogFormProps {
  children: React.ReactNode
  className?: string
  formOnSubmit: (e: React.FormEvent) => void
  actionButtonLabel: React.ReactNode
  actionButtonLoading: boolean
  actionButtonDesign?: ButtonDesigns
  cancelButtonLabel: React.ReactNode
  cancelButtonDesign?: ButtonDesigns
  cancelButtonOnClick?: () => void
  isFormValid: boolean
  error?: string
  showCancelAsLink?: boolean
}

const ModalDialogForm: React.FC<ModalDialogFormProps> = (props) => {
  const translate = useTranslate()

  const dispatch = useDispatch()

  const { children } = props

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <form
        onSubmit={(e: React.FormEvent): void => {
          e.preventDefault()
          props.formOnSubmit(e)
        }}
      >
        {children}
        {props.error !== undefined && (
          <ErrorList
            errors={[props.error]}
            css={css`
              margin-top: 10px;
              margin-bottom: 10px;
            `}
          />
        )}
        <div
          css={css`
            display: flex;
          `}
        >
          <TestId testId={'submitBtn'}>
            <Button
              design={props.actionButtonDesign || ButtonDesigns.designRed}
              type={ButtonTypes.submit}
              big={true}
              text={props.actionButtonLabel}
              loading={props.actionButtonLoading}
              disabled={props.actionButtonLoading || !props.isFormValid}
            />
          </TestId>
          {props.showCancelAsLink ? (
            <HoverableLink
              key={0}
              css={css`
                display: flex;
                align-items: center;
                float: right;
                margin-left: 20px;
              `}
              ariaLabelSource={'Cancel'}
              onClick={
                props.cancelButtonOnClick ||
                ((): void => {
                  dispatch(closeModal())
                })
              }
            >
              {translate('Cancel')}
            </HoverableLink>
          ) : (
            <Button
              design={
                props.cancelButtonDesign || ButtonDesigns.designCtaInverse
              }
              type={ButtonTypes.button}
              big={true}
              text={props.cancelButtonLabel}
              onClick={
                props.cancelButtonOnClick ||
                ((): void => {
                  dispatch(closeModal())
                })
              }
              css={css`
                margin-left: 20px;
              `}
            />
          )}
        </div>
      </form>
    </div>
  )
}

export default ModalDialogForm
